/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.4.14",
    versionName: "0.2.0-nightly.2026.4.14",
    versionChannel: "nightly",
    buildDate: "2026-04-14T00:19:03.396Z",
    commitHash: "2ac65899bba831df7b282264a7922d4f6333c974",
};
